import defaultSource from "./defaultSource.js";
export default (function sourceRandomPareto(source) {
    function randomPareto(alpha) {
        if ((alpha = +alpha) < 0)
            throw new RangeError("invalid alpha");
        alpha = 1 / -alpha;
        return function () {
            return Math.pow(1 - source(), alpha);
        };
    }
    randomPareto.source = sourceRandomPareto;
    return randomPareto;
})(defaultSource);
